/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import { ICustomElement, noShadowDOM } from 'component-register';
import Popup, { PopupProps } from './Popup';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-popup': Partial<HTMLElement> &
        PopupProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidPopup(): void {
  customElement(
    'tc-popup',
    {
      // Include ALL component properties with default values here
      // This is CRITICAL for proper property synchronization
      show: false,
      name: undefined,
      heading: undefined,
      subHeading: undefined,
      content: undefined,
      overflowClass: undefined,
      overflowStyle: undefined,
      hideFooter: false,
      hideClose: false,
      overlayClass: undefined,
      role: undefined,
      'aria-modal': undefined,
      'aria-labelledby': undefined,
      closeOnBackdropClick: false,
      backdropAndCloseDisabled: false,
      onPrimaryAction: undefined,
      onSecondaryAction: undefined,
      onClose: undefined,
      primaryBtnLabel: undefined,
      primaryBtnClass: undefined,
      primaryBtnDisabled: false,
      secondaryBtnLabel: undefined,
      secondaryBtnClass: undefined,
      secondaryBtnDisabled: false,
      headingStyleClass: undefined,
    },
    (props) => {
      noShadowDOM();
      return <Popup {...props} />;
    }
  );
}
